export default __webpack_public_path__ + "static/media/cover3.48ac2024.jpg";